import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";

const TitleDetails = ({ clingenRepoUrl }) => {
  if (clingenRepoUrl) {
    return (
      <div className="tw-inline-flex tw-items-center tw-float-right">
        <span className="tw-mr-3">
          <small>
            <a href={getVarsoUrl(clingenRepoUrl)} target="_blank">
              View full records on ClinGen
            </a>
          </small>
        </span>
      </div>
    );
  }
  return null;
};

TitleDetails.propTypes = {
  clingenRepoUrl: PropTypes.string,
};

TitleDetails.defaultProps = {
  clingenRepoUrl: "",
};

export default TitleDetails;
